import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ModelType } from '@entities/Auto';

export const getModels = createAsyncThunk<ModelType[], number>('autoParams/getModels', async markId => {
  return await MyAxios.get(`/api/catalog/v1/get-auto-model?markId=${markId}`).then(handleResponse).catch(handleError);
});
